var _path, _path2, _path3, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 225 150",
    width: "1em",
    height: "1em",
    className: "svg-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f93",
    d: "M0 0h225v150H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 50h225v100H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#128807",
    d: "M0 100h225v50H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(112.5 75)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 20,
    fill: "#008"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 17.5,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.5,
    fill: "#008"
  }), /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    fill: "#008"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 0.875,
    transform: "rotate(7.5 -8.75 133.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 17.5L.6 7 0 2l-.6 5L0 17.5z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "rotate(15)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "rotate(30)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    transform: "rotate(60)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    transform: "rotate(120)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    transform: "rotate(-120)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIn);
export default __webpack_public_path__ + "static/media/in.2ba1ab6145ae887443be641884868058.svg";
export { ForwardRef as ReactComponent };